{
  "version": "0.2.0",
  "gitCommitHash": "9e226e7d2b4ef891677c3799003716949ed210fd",
  "gitCommitShortHash": "9e226e7",
  "gitBranch": "HEAD",
  "gitTags": "",
  "clean": true
}